import React from 'react';
import PropTypes from 'prop-types';

import CoreDivider, { DividerProps } from '../../../Divider';

const Divider = (props: DividerProps) => <CoreDivider {...props} />;

Divider.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: PropTypes.string,
};

Divider.displayName = 'Card.Divider';

export default Divider;
